import Swiper from "swiper/bundle";

const defaultConfig = {
  spaceBetween: 20,
  slidesPerView: 1,
  lazy: {
    loadPrevNext: true,
  },
  breakpoints: {
    1023: {
      slidesPerView: 3,
    },
    767: {
      slidesPerView: 2,
    },
  },
}

const fourCardsConfig = {
  spaceBetween: 10,
  slidesPerView: 1,
  lazy: {
    loadPrevNext: true,
  },
  breakpoints: {
    1023: {
      slidesPerView: 4,
    },
    767: {
      slidesPerView: 3,
    },
    580: {
      slidesPerView: 2,
    },
  },
}

const CardsSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".cardsSlider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const config = slider.classList.contains("cards--four") ? fourCardsConfig : defaultConfig;
      const initSlider = new Swiper(slider, config);
    });
  }
};

export default CardsSlider;
